<template>
  <section>
    <div class="row">
      <div class="col-12">
        <h4>Compartir con</h4>
        <p>Seleccione los destinatarios que van a realizar el seguimiento del documento.</p>
      </div>
      <div class="wrapper-content px-3">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <LmTreeSelect
                class="col-auto"
                multiple
                label="Usuarios"
                pathToGetOptions="/users/all"
                :value="value"
                @input="onShareWithChange"
              />
            </div>
          </div>

          <div class="col-6">
              <b-list-group v-if="value.length">
                <b-list-group-item v-for="(user, index) of value" :key="index">
                  <div class="d-flex align-items-center">
                    <font-awesome-icon
                      class="mr-2 fa-lg"
                      icon="user"
                    />
                    <span class="flex-grow-1">
                      {{ user.name }}
                    </span>
                    <font-awesome-icon
                      class="clickable fa-lg"
                      icon="times"
                      @click="onDeleteRecipient(index)"
                    />
                  </div>
                </b-list-group-item>
              </b-list-group>
              <div v-else>
                <LmSvgIcon
                  icon="LmNoDataIcon"
                  width="7.5em"
                  wrapperClass="mb-4 d-flex justify-content-center"
                />
                <p class="text-center">
                  Todavía no se han seleccionado destinatarios para este documento.
                </p>
              </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default {
  components: {
    LmTreeSelect
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      users: []
    }
  },
  methods: {
    onShareWithChange (event) {
      this.users = event
      this.$emit('input', event)
    },
    onDeleteRecipient (index) {
      this.users.splice(index, 1)
      this.$emit('input', this.users)
    }
  }
}
</script>
